import type { en } from "./en";

// Dari (Persian, Afghanistan) translations. Missing keys fall back to English via i18next.
export const prs: typeof en = {
  common: {
    home: "خانه",
    no_scores: "هنوز نمره‌ای نیست",
    points_count_one: "{{count}} نمره",
    points_count_other: "{{count}} نمره",
    questions_count_one: "{{count}} سوال",
    questions_count_other: "{{count}} سوال",
  },
  home: {
    placeholder: "کود بازی",
    enter: "داخل شو",
    error_invalid_code: "کود ۶ حرفی بازی را که معلمت داده است وارد کن.",
    footer: "Binogi Buzz را از محصولات Binogi.com شروع کن.",
    language_label: "زبان",
  },
  errors: {
    generic: "مشکلی پیش آمد. دوباره کوشش کن.",
    stale_client: "صفحه‌ات کهنه شده — لطفاً آن را تازه کن.",
    session_not_found: "این جلسه پیدا نشد.",
    session_not_open: "این جلسه تمام شده است.",
    session_not_active: "این سوال یا جلسه قبلاً تمام شده است.",
    not_teacher: "تنها معلم می‌تواند این کار را بکند.",
    already_answered: "تو قبلاً به این سوال جواب داده‌ای.",
    wrong_question_index: "این سوال هنوز شروع نشده است.",
    name_taken: "این نام قبلاً گرفته شده. نام دیگری امتحان کن.",
    character_busy: "همین حالا نتوانستیم برایت یک کرکتر بدهیم — دوباره کوشش کن.",
  },
  host: {
    input: {
      heading: "Buzz را شروع کن",
      lead:
        "کود درس Binogi را که شاگردانت می‌خوانند وارد کن. ما سوالاتش را بار می‌کنیم و یک جلسه می‌سازیم که می‌توانی روی تخته نشان دهی.",
      lesson_code_label: "کود درس",
      placeholder_code: "BIH750",
      load_button: "بار کردن درس",
      try_hint: "امتحان کن:",
      error_invalid_code: "کود درس Binogi وارد کن، مثلاً BIH750.",
      error_not_found: "درسی با کود {{code}} پیدا نشد.",
      error_unreachable: "به سرور درس‌ها وصل نشد. اتصالت را بررسی کن و دوباره کوشش کن.",
      error_no_questions: "درس {{code}} سوالی ندارد که Buzz بتواند از آن استفاده کند.",
      error_no_level_questions: "درس {{code}} در سطح انتخاب‌شده سوالی ندارد.",
    },
    loading: "درس بار می‌شود…",
    placeholder_title: "Binogi Buzz را شروع کن",
    tab_details: "جزئیات",
    tab_questions: "سوالات",
    settings: "تنظیمات",
    number_of_students: "تعداد شاگردان",
    fewer_students: "شاگردان کمتر",
    more_students: "شاگردان بیشتر",
    player_names: "نام‌های بازیکنان",
    player_anonymous: "بی‌نام",
    player_self_chosen: "شاگردان انتخاب می‌کنند",
    language: "زبان",
    language_teacher: "معلم انتخاب می‌کند",
    language_students: "شاگردان انتخاب می‌کنند",
    time_per_question: "وقت برای هر سوال",
    time_option: "{{seconds}} ثانیه",
    start_button: "شروع جلسه",
    start_disabled: "برای شروع، تعداد صنف را تعیین کن",
    creating: "جلسه ساخته می‌شود…",
    error_no_questions: "پیش از شروع، حد اقل یک سوال نگه دار.",
    error_create_failed: "ساختن جلسه ناکام شد",
    error_load_failed: "بار کردن درس ناکام شد",
    no_session: "هیچ جلسه‌ای در جریان نیست.",
    back_to_review: "بازگشت به سوال‌ها",
    errors: {
      dismiss: "بستن",
      refresh: "تازه کردن",
      attach_failed: "این صفحه نتوانست به‌حیث معلم وصل شود.",
      unreachable: "به سرور وصل نشد. برای کوشش دوباره، صفحه را تازه کن.",
      no_token: "این تب دیگر نمی‌تواند مسابقه را اداره کند. برای شروع جلسهٔ نو، Buzz را از درس خود باز کن.",
      taken_over: "این مسابقه حالا از یک صفحهٔ دیگر اداره می‌شود.",
      stale_question: "Buzz در جریان این مسابقه به‌روز شد، پس این صفحه نمی‌تواند آن را ادامه دهد. صفحه را دوباره بار کن تا مسابقه از همان جایی که صنف است ادامه پیدا کند.",
      question_moved_on: "مسابقه از این سؤال گذشته است، پس این صفحه عقب مانده است. صفحه را دوباره بار کن تا مسابقه از همان جایی که صنف است ادامه پیدا کند.",
    },
    entry: {
      opening: "نمای معلم باز می‌شود…",
      token_title: "این لینک معلم باز نمی‌شود",
      token_body: "کلید معلم در لینک نیست یا وقت آن تمام شده است. برای ساختن جلسهٔ نو، Buzz را از درس خود باز کن.",
      not_found_title: "جلسه پیدا نشد",
      not_found_body: "این جلسهٔ مسابقه دیگر وجود ندارد. برای ادامه، یک جلسهٔ نو بساز.",
      back: "بازگشت به شروع",
    },
    questions: {
      drag_aria: "برای تغییر ترتیب بکش",
      remove_aria: "سوال را حذف کن",
      empty: "هیچ سوالی در این جلسه باقی نمانده.",
      add: "افزودن",
      add_aria: "افزودن سوال: {{text}}",
      add_all: "افزودن همه",
      add_all_n: "افزودن هر {{count}} سوال",
      more_one: "{{count}} سوال دیگر در این درس",
      more_other: "{{count}} سوال دیگر در این درس",
      level_easy: "آسان",
      level_medium: "متوسط",
      level_hard: "دشوار",
      multi: "چندگزینه‌ای",
    },
    lobby: {
      go_to: "به <strong>buzz.binogi.com</strong> برو و وارد کن:",
      or_qr: "…یا کود QR را اسکن کن",
      students_joined_of: "{{joined}} از {{expected}} شاگرد داخل شدند",
      students_joined_one: "{{count}} شاگرد داخل شد",
      students_joined_other: "{{count}} شاگرد داخل شدند",
      waiting: "منتظر داخل شدن شاگردان…",
      start_game: "شروع بازی",
      connected: "وصل شد",
      connecting: "در حال وصل شدن…",
      copy_link: "کاپی کردن لینک",
      copy_link_copied: "کاپی شد!",
    },
    question: {
      header: "سوال {{index}} از {{total}}",
      level: "سطح {{level}}",
      none: "هیچ سوال فعالی نیست.",
      answered: "جواب داد",
      top_n: "{{count}} نفر برتر",
      answers_heading: "جواب‌ها",
      end_question: "ختم سوال",
      next_question: "سوال بعدی",
      see_results: "دیدن نتایج نهایی",
    },
    results: {
      heading: "نتایج نهایی",
      all_players: "همه بازیکنان",
      end_session: "ختم جلسه",
      new_session: "جلسه جدید",
      none: "هیچ بازیکنی در این جلسه نیست.",
    },
  },
  join: {
    code_label: "کود بازی",
    name_label: "نام تو",
    name_placeholder: "نامت را بنویس",
    join_button: "داخل شو",
    joining: "در حال داخل شدن…",
    checking: "بررسی می‌شود…",
    character_hint: "وقتی داخل شوی، یک نام بامزه از شخصیت‌های Binogi می‌گیری.",
    error_not_found:
      "این کود هنوز یک جلسه فعال نیست. با معلمت بررسی کن.",
    error_lookup_failed: "پیدا کردن جلسه ناکام شد",
    error_code_required: "کود ۶ حرفی را وارد کن.",
    error_name_required: "نامت را بنویس.",
  },
  play: {
    superseded: "شما در تب دیگری متصل هستید — برای ادامه بازی در اینجا آن را ببندید.",
    back_to_join: "بازگشت به پیوستن",
    no_round: "معلوماتی از این دور نیست.",
    not_joined: "تو به هیچ جلسه‌ای داخل نشده‌ای.",
    no_question: "هیچ سوال فعالی نیست.",
    keep_awake_hint: "برای روشن ماندن صفحه، روی آن ضربه بزنید",
    waiting: {
      you_are: "تو هستی",
      get_ready_named: "آماده شو، {{name}}!",
      get_ready: "برای امتحان آماده شو!",
      in_room_label: "شاگردان در اتاق",
      in_room_one: "{{count}} شاگرد در اتاق",
      in_room_other: "{{count}} شاگرد در اتاق",
    },
    question: {
      progress: "{{index}} / {{total}}",
      answered: "جواب داده شد!",
      times_up: "وقت تمام شد",
      submit: "روان کن",
      submit_n: "روان کردن {{count}} جواب",
    },
    between: {
      correct: "درست است!",
      wrong: "نزدیک بود!",
      times_up: "وقت تمام شد",
      points_gained: "+{{count}} نمره",
      your_score: "نمره تو",
      your_rank: "رتبه تو: {{rank}}",
      top_n: "{{count}} نفر برتر",
      waiting_next: "منتظر سوال بعدی…",
    },
    finished: {
      heading: "تشکر که Binogi Buzz بازی کردی!",
      your_final_rank: "رتبه نهایی تو",
      top_n: "{{count}} نفر برتر",
      none: "هیچ نتیجه‌ای برای نشان دادن نیست.",
    },
  },
  characters: {
    heading: "شخصیت‌های Binogi",
    lead: "{{count}} شاگرد به همین ترتیب، وقتی داخل می‌شوند یک شخصیت می‌گیرند.",
  },
};
